import { SET_PDS } from './types';

export const setPds = pds => ({ type: SET_PDS, pds });
